import { axiosInstance as axios } from 'Api';
import { Config } from 'Constants/config_env';
import { handlingResponse } from '../../../utils/globalMethods.js';

/**  @function
 * * logout user from Backoffice
 *
 * @name logoutUser
 * @returns {object} the object contains ?
 */
export const logoutUser = async (params) => {
	let response;
	try {
		response = await axios({
			method: 'get',
			url: Config.logout_user,
			data: params,
		});
		return handlingResponse(response);
	} catch (error) {
		console.error(error);
	}
};

/**  @function
 * get code hash
 * @name retrieveCodeHash
 * @returns undefined
 */
export const retrieveCodeHash = () => {
	if (location.search.length > 0 || location.hash.length > 0) {
    const search = location.search.length > 0 ? location.search.substring(1) : location.hash.substring(1);
    const object = JSON.parse(`{"${search.replace(/&/g, '","').replace(/=/g, '":"')}"}`, (key, value) => (key === '' ? value : decodeURIComponent(value)));
		Object.keys(object).includes('method') ? window.sessionStorage.setItem('isOtp', true) : window.sessionStorage.setItem('codeHashUE', JSON.stringify(object));
		window.location.replace(Config.user_enrollment_redirect_uri);
	}
};
